export const SYNDICATED_COMPONENT_ID = 'global-header'
